import { EventEmitter } from 'events';

const eventBus = new EventEmitter();

export const EVENTS = {
    FAVORITES_UPDATED: 'favorites_updated',
};

export default eventBus;
